var DDWidth = /* @__PURE__ */ ((DDWidth2) => (DDWidth2[DDWidth2.XS = 180] = "XS", DDWidth2[DDWidth2.SM = 240] = "SM", DDWidth2[DDWidth2.MD = 300] = "MD", DDWidth2[DDWidth2.LG = 360] = "LG", DDWidth2))(DDWidth || {});
export {
  DDWidth
};
//# sourceMappingURL=DDWidth.js.map
